import { http } from '../../config/axios'

export default function restaurarPlano(idPlano: string, idCliente:string, idPlanoOrigem : string): Promise<string> {
  return http
    .delete('api/plano/retornarplano/'+idPlano+'/'+idCliente+'/'+idPlanoOrigem)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro restaurarPlano', error)
      throw Error(error.response.data)
    })
}
